import React, { FC } from "react";

import { PageRoot } from "./styles";

const StaticPageRenderer: FC<{ children: string }> = ({ children }) => {
  return <PageRoot dangerouslySetInnerHTML={{ __html: children }} />;
};
export default StaticPageRenderer;
